<app-header></app-header>
<div class='govpl-spacer'></div>
<main>
  <div>
    <header>
    </header>
    <section class='gov-services blue-bar-row blue-bar-row--epolak'>
      <div class='main-container'>
        <div class='blue-bar'>
          <div class='blue-bar-content'>
            <h2>Załatwiaj sprawy urzędowe</h2>
            <span class='subheader'>przez internet, bezpiecznie i wygodnie!</span>
            <form class='search-form' [formGroup]='form' (submit)='onSearch()' novalidate>
              <input formControlName='query' placeholder='Szukaj usług'
                     aria-label='Wpisz nazwę do wyszukania. Naciśnij TAB aby przejść do przycisku.'>
              <button type='submit'>
                <span class='sr-only'>Wyszukaj</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class='gov-services'>
      <div class='main-container'>
        <div class='tabs-container'>
          <div>
            <ul id='services-tabs' role='tablist'>
              <li role='tab'>
                <a
                  #servicesTab
                  id='services-tab'
                  aria-controls='services'
                  href='#'
                  (click)="$event.preventDefault(); activeTab = servicesTab"
                  [ngClass]="{ active: activeTab === servicesTab }">
                  Usługi
                </a>
              </li>
            </ul>
          </div>
        </div>
        <br>
        @if (activeTab === servicesTab) {
          <div id='services' class='tab-content' aria-labelledby='services-tab'>
            <ul>
              @for (item of services(); track $index) {
                @if (($index < 12) && !item.isCaseRelated) {
                  <li>
                    <a [routerLink]='"/e-uslugi" + item.url'>
                      <img src='/img/icons/services/13-pismo-ogolne-do-urzedu.svg' alt=''>
                      <span>{{ item.name }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
            <div class='center-buttons'>
              <a class='see-more-button btn btn-secondary' routerLink='/e-uslugi'>
                Zobacz wszystkie usługi
              </a>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
</main>
<app-footer></app-footer>
